import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=745aa98e&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"
import style0 from "./Modal.vue?vue&type=style&index=0&id=745aa98e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745aa98e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('745aa98e')) {
      api.createRecord('745aa98e', component.options)
    } else {
      api.reload('745aa98e', component.options)
    }
    module.hot.accept("./Modal.vue?vue&type=template&id=745aa98e&scoped=true", function () {
      api.rerender('745aa98e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/compliance/SupervisedPersonManager/Modal.vue"
export default component.exports